// A tradução: o que aquele item significa, em português de família.
//
// Esta é a parte do sistema que não é para o médico. Ele já tem os números no
// prontuário. Isto é para quem está no quarto e olha "PCR 13,36" sem saber se
// deve ficar aliviado ou preocupado.
//
// O texto sai do glossário escrito à mão em packages/shared — informação de
// livro-texto, fixa, sem IA e sem internet. E termina sempre em PERGUNTA, não
// em conclusão: o objetivo é chegar na visita sabendo o que perguntar.
import { useEffect } from 'react';
import { RODAPE_EXPLICACAO } from '@medicov1/shared';
import './explicar.css';

export interface Explicacao {
  titulo: string;
  /** Uma frase sobre a situação, quando houver ("Não cresceu nada"). */
  situacao?: string;
  texto: string;
  pergunta?: string;
  /** Muda a cor da tarja lateral. */
  peso?: 'aguardando' | 'tranquilizador' | 'atencao' | 'neutro';
}

interface Props {
  explicacao: Explicacao | null;
  aoFechar: () => void;
}

export function Explicar({ explicacao, aoFechar }: Props) {
  // Esc fecha: quem abriu por engano não fica preso.
  useEffect(() => {
    if (!explicacao) return;
    const aoTeclar = (e: KeyboardEvent) => { if (e.key === 'Escape') aoFechar(); };
    document.addEventListener('keydown', aoTeclar);
    return () => document.removeEventListener('keydown', aoTeclar);
  }, [explicacao, aoFechar]);

  if (!explicacao) return null;

  return (
    <div className="explicar" onClick={aoFechar} role="presentation">
      <div
        className={`explicar__caixa explicar__caixa--${explicacao.peso ?? 'neutro'}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label={`O que significa: ${explicacao.titulo}`}
      >
        <header className="explicar__topo">
          <div>
            <h2>{explicacao.titulo}</h2>
            {explicacao.situacao && <p className="explicar__situacao">{explicacao.situacao}</p>}
          </div>
          <button className="explicar__fechar" onClick={aoFechar} aria-label="fechar">×</button>
        </header>

        <p className="explicar__texto">{explicacao.texto}</p>

        {explicacao.pergunta && (
          <section className="explicar__pergunta">
            <span>Para perguntar na visita</span>
            <p>“{explicacao.pergunta}”</p>
          </section>
        )}

        {/* Repetido na tela, e não só na documentação: quem lê às três da
            manhã não leu a documentação. */}
        <p className="explicar__rodape">{RODAPE_EXPLICACAO}</p>

        <button className="botao explicar__ok" onClick={aoFechar}>Entendi</button>
      </div>
    </div>
  );
}
